<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<v-card v-on:keyup.enter="buildNewSearch">
		<v-card-title>
			<h2>Użytkownicy</h2>
			<v-spacer></v-spacer>
		</v-card-title>
		<v-dialog v-model="dialog" max-width="1000px">
			<v-btn slot="activator" color="primary" dark class="mb-2 mt-4" v-if="!roles.isDepartmentEmployee()">Dodaj
				użytkownika
			</v-btn>
			<v-card id="create">
				<v-card-title>
					<span class="headline" v-if="isEdited"> Edycja użytkownika </span>
					<span class="headline" v-else> Dodaj nowego użytkownika </span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
						<v-layout wrap>
							<v-flex xs12 sm6 md4>
								<v-text-field v-model="editedItem.email" label="E-mail *"
									browser-autocomplete="email"
									for="users-view-email*"
									id="users-view-email*"
									data-vv-name="email"
									data-vv-as="E-mail"
									aria-label="email"
									:error-messages="vErrors.collect('email')"
									v-validate="'required|email'"
									data-vv-validate-on="change"
									v-on:change="validateEmail"></v-text-field>
							</v-flex>
							<v-flex xs12 sm6 md4>
								<v-text-field v-model="editedItem.name" label="Imię *"
									browser-autocomplete="given-name"
									for="users-view-name*"
									id="users-view-name*"
									data-vv-name="name"
									data-vv-as="Imię"
									aria-label="name"
									:error-messages="vErrors.collect('name')"
									v-validate="'required'"></v-text-field>
							</v-flex>
							<v-flex xs12 sm6 md4>
								<v-text-field v-model="editedItem.surname" label="Nazwisko *"
									browser-autocomplete="family-name"
									for="users-view-surname*"
									id="users-view-surname*"
									data-vv-name="surname"
									data-vv-as="Nazwisko"
									aria-label="surname"
									:error-messages="vErrors.collect('surname')"
									v-validate="'required'"></v-text-field>
							</v-flex>
							<v-flex xs12 sm6 md4 v-if="editedItem.role === 'Wolontariusz'
								|| editedItem.role === 'Oferent - konto główne' || editedItem.role === 'Oferent - subkonto'">
								<v-text-field name="Rola" v-model="editedItem.role" label="Rola *"
									browser-autocomplete="organization-title"
									for="users-view-role"
									id="users-view-role"
									aria-label="role"
									disabled></v-text-field>
							</v-flex>
							<v-flex xs12 sm6 md4 v-else>
								<v-autocomplete name="Rola" v-model="editedItem.role" :items="availableRoleList()"
									label="Rola *"
									aria-label="role"
									for="users-view-role*"
									id="users-view-role*"
									data-vv-name="role"
									data-vv-as="Rola"
									:error-messages="vErrors.collect('role')"
									v-validate="'required'"></v-autocomplete>
							</v-flex>
							<v-flex xs12 sm6 md4 v-if="editedItem.role === 'Pracownik placówki'">
								<v-autocomplete name="Placówka" v-model="editedItem.agencyId" clearable
									:items="agencies"
									label="Placówka *"
									aria-label="agency"
									for="users-view-agency*"
									id="users-view-agency*"
									item-value="id"
									item-text="name"
									data-vv-name="agency"
									data-vv-as="Placówka"
									:error-messages="vErrors.collect('agency')"
									v-validate="'required'"></v-autocomplete>
							</v-flex>
							<v-flex xs12 sm6 md4
								v-if="showDepartment()">
								<v-autocomplete name="Departament" v-model="editedItem.departmentId" :items="departments"
									label="Departament *"
									aria-label="department"
									for="users-view-department*"
									id="users-view-department*"
									item-value="id"
									item-text="name"
									data-vv-name="department"
									data-vv-as="Departament"
									:error-messages="vErrors.collect('department')"
									v-validate="'required'"></v-autocomplete>
							</v-flex>
							<v-flex xs12 sm6 md4>
								<v-text-field v-model="editedItem.phoneNumber"
									browser-autocomplete="tel"
									label="Numer telefonu *"
									aria-label="phone number"
									for="users-view-phone-number"
									id="users-view-phone-number"
									data-vv-name="phoneNumber"
									data-vv-as="Numer telefonu"
									:error-messages="vErrors.collect('phoneNumber')"
									v-validate="{required: true, regex: /^([(][0-9 +-]*[)])?[0-9 +-]*$/}"></v-text-field>
							</v-flex>
						</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue" @click="close" :disabled="clicked">Anuluj</v-btn>
					<v-btn color="primary" flat @click="save(editedIndex, editedItem)" :disabled="clicked"
						v-if="isEdited">Zapisz
					</v-btn>
					<v-btn color="primary" flat @click="create" :disabled="clicked" v-else>Utwórz</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-layout align-center justify-center row>
			<v-flex xs2>
				<v-text-field
					class="ma-2"
					browser-autocomplete="off"
					v-model="dataTable.searchFields.name"
					label="Imię"
					aria-label="name"
					for="users-view-name"
					id="users-view-name">
				</v-text-field>
			</v-flex>
			<v-flex xs2>
				<v-text-field
					class="ma-2"
					browser-autocomplete="off"
					v-model="dataTable.searchFields.surname"
					label="Nazwisko"
					aria-label="surname"
					for="users-view-surname"
					id="users-view-surname">
				</v-text-field>
			</v-flex>
			<v-flex xs2>
				<v-text-field
					class="ma-2"
					browser-autocomplete="off"
					v-model="dataTable.searchFields.email"
					label="E-mail"
					aria-label="email"
					for="users-view-email"
					id="users-view-email">
				</v-text-field>
			</v-flex>
			<v-flex xs2>
				<v-autocomplete
					class="ma-2" :items="systemRoles" v-model="dataTable.searchFields.role"
					label="Rola" clearable aria-label="system role"
				></v-autocomplete>
			</v-flex>
			<v-flex xs3>
				<v-layout align-center justify-center row>
					<v-btn @click="buildNewSearch" color="primary" dark class="mb-2">Szukaj</v-btn>
					<v-btn @click="resetSearch" color="primary" dark class="mb-2">Resetuj</v-btn>
					<v-btn @click="exportData" color="primary" dark class="mb-2">Eksportuj</v-btn>
				</v-layout>
			</v-flex>
		</v-layout>

		<v-data-table
			:headers="dataTable.tableHeaders"
			:rows-per-page-items="[10,20,25]"
			:loading="dataTable.loading"
			:items="dataTable.itemList"
			:total-items="dataTable.itemCount"
			:pagination.sync="dataTable.pagination"
			class="elevation-1"
		>
			<template slot="items" slot-scope="props">
				<td>{{ props.item.email }}</td>
				<td class="text-xs-left">{{ props.item.name }}</td>
				<td class="text-xs-left">{{ props.item.surname }}</td>
				<td class="text-xs-left">{{ props.item.role }}</td>
				<td class="text-xs-left">{{ props.item.registrationDate }}</td>
				<td class="text-xs-left">
					<span class="notAccepted-user" v-if="!props.item.accepted"
						style="color:darkred"><b>Niezaakceptowany</b><br></span>
					<span class="active-user" v-else-if="props.item.active" style="color:#0075e2">Aktywny</span>
					<span class="inactive-user" v-else style="color:red">Nieaktywny</span>
				</td>
				<td class="text-xs-left">
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon v-if="roles.isAdministrator() ||
									(!roles.isDepartmentEmployee()  && props.item.role !== 'Administrator główny') ||
									(roles.isLocalAdministrator() && props.item.role !== 'Administrator główny')"
								@click="editItem(props.item)" >
								<v-icon v-on="on">
									edit
								</v-icon>
							</v-btn>
						</template>
						<span>Edytuj</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon v-if="!roles.isDepartmentEmployee()"
								@click="deleteItem(props.item)" >
								<v-icon color="lightred" v-on="on">
									delete
								</v-icon>
							</v-btn>
						</template>
						<span>Usuń</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="showProfile(props.item)" >
								<v-icon v-on="on">
									person
								</v-icon>
							</v-btn>
						</template>
						<span>Profil</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon v-if="props.item.role === 'Oferent - konto główne'"
								@click="showProjects(props.item)" >
								<v-icon v-on="on">
									business
								</v-icon>
							</v-btn>
						</template>
						<span>Projekty</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon v-if="props.item.role === 'Wolontariusz'"
								@click="showVolunteerProjects(props.item)" >
								<v-icon v-on="on">
									business
								</v-icon>
							</v-btn>
						</template>
						<span>Projekty</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }" >
							<v-btn icon v-if="props.item.active && canBeAllowedToView(props.item)"
								@click="showAllowances(props.item)" >
								<v-icon v-on="on" color="primary">
									screen_share
								</v-icon>
							</v-btn>
						</template>
						<span>Udostępnienia</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn icon
								v-if="['Administrator główny', 'Administrator lokalny', 'Pracownik departamentu'].includes(props.item.role)"
								@click="showSupervisedProjects(props.item.id)">
								<v-icon v-on="on" color="primary">
									folder_shared
								</v-icon>
							</v-btn>
						</template>
						<span>Projekty opiekuna</span>
					</v-tooltip>
					<v-tooltip bottom v-if="!props.item.active && !roles.isDepartmentEmployee()">
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="activateUser(props.item)" >
								<v-icon v-on="on" color="blue">
									check_circle
								</v-icon>
							</v-btn>
						</template>
						<span>Aktywuj</span>
					</v-tooltip>
					<v-tooltip bottom v-else-if="props.item.active && !roles.isDepartmentEmployee()">
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="deactivateUser(props.item)" >
								<v-icon v-on="on" color="lightred">
									lock
								</v-icon>
							</v-btn>
						</template>
						<span>Dezaktywuj</span>
					</v-tooltip>
					<v-tooltip bottom v-if="!props.item.accepted && !roles.isDepartmentEmployee()">
						<template v-slot:activator="{ on }" >
							<v-btn icon
								@click="acceptUser(props.item)" >
								<v-icon v-on="on" style="color:darkred">
									change_history
								</v-icon>
							</v-btn>
						</template>
						<span>Zaakceptuj</span>
					</v-tooltip>
					<v-tooltip bottom max-width="480px" v-if="props.item.notes && (roles.isAdministrator() || roles.isLocalAdministrator() || roles.isDepartmentEmployee())">
						<template v-slot:activator="{ on }">
							<v-btn icon>
								<v-icon color="lightred" v-on="on">info</v-icon>
							</v-btn>
						</template>
						<span>{{ props.item.notes }}</span>
					</v-tooltip>
				</td>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
	import {Api} from "@/api";
	import {encoder} from "@/utils/encodeHelper";
	import {role} from "@/utils/Role";
	import {ExportUtils} from "@/utils/ExportUtils";
	import {Agency} from "@/api/generated/Agency";
	import {Department} from "@/api/generated/Department";
	import {User} from "@/api/generated/User";
  import {Filters} from "@/utils/Filters";

	export default {
		name: "UsersView",

    mixins: [Filters],

		watch: {
			dialog(val) {
				if (!val) {
					this.vErrors.clear();
					this.editedIndex = -1;
					this.editedItem = {};
				} else {
					Agency.getAll(this, successResponse => {
							this.agencies = successResponse;
						},
						errorResponse => {
							this.$messagesBus.$emit("error", "Nie udało się pobrać nazw placówek", errorResponse);
						});
					if (!role.isLocalAdministrator()) {
						Department.getList(this, successResponse => {
								this.departments = successResponse;
							},
							errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się pobrać nazw departamentów", errorResponse);
							});
					}
				}
			},

			"dataTable.pagination": {
				handler (pagination) {
					this.getItemList();
          this.paginationRef = pagination;
				},
				deep: true
			},
		},

    created() {
      this.dataTable.searchFields = this.retrieveFilters(this.dataTable.searchFields);
      this.dataTable.pagination = this.retrievePagination(this.dataTable.pagination);
      this.buildNewSearch();
    },

		computed: {
			pages() {
				// paginacja nie została zainicjalizowana
				if (this.dataTable.pagination.rowsPerPage === undefined) {
					return 0;
				}
				return Math.ceil(this.dataTable.itemCount / this.dataTable.pagination.rowsPerPage);
			},

			isEdited() {
				return this.editedIndex !== -1;
			}
		},

		data() {
			return {
				dataTable: {
					searchFields: {
						email: "",
						name: "",
						surname: "",
						role: ""
					},
					tableHeaders: [
						{
							text: "E-mail",
							align: "left",
							sortable: true,
							value: "email",
						},
						{text: "Imię", sortable: true, value: "name"},
						{text: "Nazwisko", sortable: true, value: "surname"},
						{text: "Rola", sortable: true, value: "role"},
						{text: "Data rejestracji", sortable: true, value: "registrationDate"},
						{text: "Status", sortable: false, value: "status"},
						{text: "Akcje", sortable: false, value: "actions"},
					],
					loading: false,
					itemList: [],
					itemCount: 0,
					pagination: {
						rowsPerPage: 25
					},
					search: "",
				},

				dialog: false,

				administratorRoleList: ["Administrator główny", "Administrator lokalny", "Pracownik departamentu",
					"Pracownik placówki", "Ekspert", "Przeglądający"],

				localAdministratorRoleList: ["Pracownik departamentu",
					"Pracownik placówki", "Ekspert", "Przeglądający"],

				systemRoles: [
					"Administrator główny",
					"Administrator lokalny",
					"Pracownik departamentu",
					"Pracownik placówki",
					"Ekspert",
					"Oferent - konto główne",
					"Oferent - subkonto",
					"Wolontariusz",
					"Przeglądający"
				],

				agencies: [],

				departments: [],

				editedItem: {},

				editedIndex: -1,

				clicked: false,
			};
		},

		methods: {
			canBeAllowedToView (item) {
				return item.role !== 'Oferent - konto główne' &&
					item.role !== 'Oferent - subkonto' &&
					item.role !== 'Wolontariusz' &&
					item.role !== 'Administrator lokalny' &&
					item.role !== 'Administrator główny' &&
					(this.roles.isAdministrator() || this.roles.isLocalAdministrator());
			},

			buildNewSearch () {
				this.dataTable.search = this.buildSearch(this.dataTable.searchFields);
				this.getItemList();
			},

			getItemList() {
				if (this.dataTable.pagination.page) {
					let sort = this.buildSort();
					Api.get(this,
						"/user/list?search=" + this.dataTable.search
							+ "&page=".concat(this.dataTable.pagination.page)
							+ "&result=".concat(this.dataTable.pagination.rowsPerPage)
							+ "&sort=".concat(sort), response => {
								this.dataTable.itemList = response.itemList;
								this.dataTable.itemCount = response.itemCount;
							});
				}
			},

			exportData () {
				let sort = this.buildSort();
				let path = "/user/export?search=" + this.dataTable.search
					+ "&page=".concat(this.dataTable.pagination.page)
					+ "&result=".concat(this.dataTable.pagination.rowsPerPage)
					+ "&sort=".concat(sort);

				ExportUtils.sendExportRequest(path, this);
			},

			buildSort () {
				let order = this.dataTable.pagination.descending === true ? "desc" : "asc";
				let columnName = this.dataTable.pagination.sortBy;
				if (order && columnName) {
					return columnName.concat(" ").concat(order);
				} else {
					return "";
				}
			},

			resetSearch() {
				this.clearFields();
				this.buildNewSearch();
			},

			clearFields() {
				this.dataTable.searchFields.name = "";
				this.dataTable.searchFields.surname = "";
				this.dataTable.searchFields.email = "";
				this.dataTable.searchFields.role = "";
			},

			availableRoleList() {
				if (role.isAdministrator()) {
					return this.administratorRoleList;
				}

				if (role.isLocalAdministrator()) {
					return this.localAdministratorRoleList;
				}
			},

			buildSearch(searchFields) {
				let search = "";
				if (searchFields.email) {
					search = search.concat("email::" + searchFields.email + "$$");
				}
				if (searchFields.name) {
					search = search.concat("name::" + searchFields.name + "$$");
				}
				if (searchFields.surname) {
					search = search.concat("surname::" + searchFields.surname + "$$");
				}
				if (searchFields.role) {
					search = search.concat("role::" + searchFields.role + "$$");
				}
				return search;
			},

			editItem(item) {
				this.editedIndex = this.dataTable.itemList.indexOf(item);
				this.editedItem = Object.assign({}, item);
				this.dialog = true;
			},

			deleteItem(item) {
        let confirmationMessage = "Czy na pewno chcesz usunąć użytkownika?";
        const unacceptedBidder = item.role === "Oferent - konto główne" && !item.accepted;

        if (unacceptedBidder) {
          confirmationMessage = confirmationMessage.concat(" Operacja usunięcia niezaakceptowanego oferenta jest " +
              "nieodwracalna. Użytkownik zostanie trwale usunięty z systemu.");
        }

				this.$confirm(confirmationMessage, {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie użytkownika",
					width: 500
				})
					.then(result => {
						if (result) {
							const index = this.dataTable.itemList.indexOf(item);
							User.delete(this, item.id, successResponse => {
									this.dataTable.itemList.splice(index, 1);
									this.$messagesBus.$emit("success", "Użytkownik został pomyślnie usunięty", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się usunąć użytkownika", errorResponse);
								});
						}
					});
			},

			showProfile (item) {
				if (this.roles.isAdministrator() || this.roles.isLocalAdministrator()) {
					this.$router.push("/app/profile/" + item.id);
				} else {
					this.$router.openInNewTab({name: "profileView", params: {userId: item.id}});
				}
			},

			showAllowances (item) {
				this.$router.push("/app/allowances/" + item.id);
			},

			showSupervisedProjects (userId) {
				this.$router.push("/app/supervised-projects/".concat(userId));
			},

			showProjects(item) {
				this.$router.push("/app/project/bidder-project-list/".concat(item.id));
			},

			showVolunteerProjects(item) {
				this.$router.push("/app/project/volunteer-project-list/".concat(item.id));
			},

			showDepartment() {
				return (this.editedItem.role === "Pracownik departamentu" || this.editedItem.role === "Administrator lokalny") && role.isAdministrator();
			},

			close() {
				this.dialog = false;
			},

			save(index, item) {
				if (index > -1) {
					this.$validator.validateAll().then((result) => {
						if (!result) return;
						item.currentEmail = this.dataTable.itemList[index].email;
						Api.post(this, "/user-register/update-user", item, successResponse => {
								this.close();
								this.$messagesBus.$emit("success", "Użytkownik został pomyślnie zapisany", successResponse);
							},
							errorResponse => {
								if(errorResponse && errorResponse.errors.includes("DUPLICATE_EMAIL") && errorResponse.message){
 									this.$messagesBus.$emit("error", errorResponse.message, errorResponse);
								} else {
								this.$messagesBus.$emit("error", "Nie udało się zapisać użytkownika", errorResponse);
							}
							});
						Object.assign(this.dataTable.itemList[index], item);
						this.close();
					});
				}
			},

			create() {
				this.clicked = true;
				this.validateEmail(this.editedItem.email);
				this.$validator.validateAll().then((result) => {
					if (!result) {
						this.clicked = false;
						return;
					}
					Api.post(this, "/user-register/register-inner", this.editedItem, successResponse => {
						if (this.editedIndex > -1) {
							Object.assign(this.dataTable.itemList[this.editedIndex], this.editedItem);
							this.$messagesBus.$emit("success", "Użytkownik został pomyślnie zapisany", successResponse);
						} else {
							this.$messagesBus.$emit("success", "Użytkownik jest w zakładce \"Niepotwierdzeni użytkownicy\"", successResponse);
						}
						this.close();
						this.clicked = false;
					}, errorResponse => {
						this.clicked = false;
						this.$messagesBus.$emit("error", "Nie udało się zapisać użytkownika", errorResponse);
					});
				});

			},

			validateEmail(email) {
				return Api.get(this, "/user/validate-email-uniqueness?email=".concat(encoder.encodeUrlParam(email)), response => {
					if (response.unique === false) {
						this.$messagesBus.$emit("error", "Użytkownik o takim e-mail już istnieje w systemie", response);
					}
				});
			},

			acceptUser(user) {
				this.$confirm("Czy na pewno chcesz zaakceptować użytkownika?", {
					icon: "warning",
					title: "Akceptacja użytkownika",
					color: "info",
					width: 500
				})
					.then(result => {
						if (result) {
							Api.post(this, "/user/accept", {email: user.email}, successResponse => {
									user.accepted = true;
									this.$messagesBus.$emit("success", "Użytkownik został pomyślnie zaakceptowany", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się zaakceptować użytkownika", errorResponse);
								});
						}
					});
			},

			activateUser(user) {
				this.$confirm("Czy na pewno chcesz aktywować użytkownika?", {
					icon: "warning",
					title: "Aktywacja użytkownika",
					color: "info",
					width: 500
				})
					.then(result => {
						if (result) {
							Api.post(this, "/user/activate", {email: user.email}, successResponse => {
									user.active = true;
									this.$messagesBus.$emit("success", "Użytkownik został pomyślnie aktywowany", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się aktywować użytkownika", errorResponse);
								});
						}
					});
			},

			deactivateUser(user) {
				this.$confirm("Czy na pewno chcesz dezaktywować użytkownika?", {
					icon: "warning",
					title: "Dezaktywacja użytkownika",
					color: "info",
					width: 500
				})
					.then(result => {
						if (result) {
							Api.post(this, "/user/deactivate", {email: user.email}, successResponse => {
									user.active = false;
									this.$messagesBus.$emit("success", "Użytkownik został pomyślnie dezaktywowany", successResponse);
								},
								errorResponse => {
									this.$messagesBus.$emit("error", "Nie udało się dezaktywować użytkownika", errorResponse);
								});
						}
					});
			},
		},
	};
</script>

<style scoped>
	.theme--dark .notAccepted-user {
		color: #fff !important;
	}

	.theme--dark .inactive-user {
		color: #D5233F !important;
	}

	.theme--dark .active-user {
		color: #fff !important;
	}

	.theme--dark.v-icon {
		color: #fff !important;
	}


	.theme--dark .red--text {
		color: #f4ec0d !important;
	}

	.theme--dark .green--text {
		color: #fff !important;
	}
</style>
